import { loadSrcToImage } from "../loadSrcToImage";

export async function flipImage(
    flipH: boolean,
    flipV: boolean,
    currentImage: HTMLImageElement,
    src: string,
    width: number,
    height: number,
) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    if (!context) return;
    const dpr = window.devicePixelRatio;
    canvas.width = currentImage.width * dpr;
    canvas.height = currentImage.height * dpr;

    const image = new Image();
    image.src = src;
    image.style.transform = "scale(-1, 1)";
    image.width = canvas.width;
    image.height = canvas.height;

    context.clearRect(0, 0, canvas.width, canvas.height);

    await new Promise<void>((resolve, reject) => {
        image.onload = () => {
            resolve();
        };
        image.onerror = (e) => {
            reject();
        };
    });

    if (flipH) {
        context.translate(width * dpr, 0);
        context.scale(-1, 1);
    }

    if (flipV) {
        context.translate(0, height * dpr);
        context.scale(1, -1);
    }

    context.drawImage(image, 0, 0, canvas.width, canvas.height);
    await loadSrcToImage(canvas.toDataURL(), currentImage);
}
